import api from '../utils/api';
import useFlashMessage from './useFlashMessage';

export default function useSubscription() {
    const { setFlashMessage } = useFlashMessage();

     /* ─────────────────────────────────────────────────────────────
       subscribe(token, planName)
       Detecta upgrade / downgrade no backend automaticamente.
       Retorna:
         { init_point }  → redirecionar para o checkout MP (upgrade)
         { downgraded }  → plano rebaixado direto, sem checkout
         { error }       → erro
    ───────────────────────────────────────────────────────────── */
    // src/hooks/useSubscription.js
// Troca a função subscribe por essa versão:

    async function subscribe(token, planName, cardTokenId) {
        try {
            const response = await api.post(
                '/subscriptions/create',
                { planName, cardTokenId },   // ← manda o token do cartão junto
                { headers: { Authorization: `Bearer ${token}` } },
            );
            const data = response.data;

            if (data.downgraded) {
                setFlashMessage('Plano rebaixado para Gratuito com sucesso.', 'success');
                return { downgraded: true };
            }

            if (data.authorized) {
                setFlashMessage('Assinatura ativada com sucesso!', 'success');
                return { authorized: true, subscription: data.subscription };
            }

            return { error: true };
        } catch (error) {
            const msg = error.response?.data?.message || 'Erro ao iniciar assinatura.';
            setFlashMessage(msg, 'error');
            return { error: true };
        }
    }

    /* Cancela assinatura ativa */
    async function cancelSubscription(token, subscriptionId) {
        try {
            const response = await api.put(
                `/subscriptions/${subscriptionId}/cancel`,
                {},
                { headers: { Authorization: `Bearer ${token}` } },
            );
            setFlashMessage('Assinatura cancelada com sucesso.', 'success');
            return response.data;
        } catch (error) {
            const msg = error.response?.data?.message || 'Erro ao cancelar assinatura.';
            setFlashMessage(msg, 'error');
            return { error: true };
        }
    }

    /* Troca de plano */
    async function updateSubscription(token, subscriptionId, newPlanName) {
        try {
            const response = await api.put(
                `/subscriptions/${subscriptionId}/update`,
                { newPlanName },
                { headers: { Authorization: `Bearer ${token}` } },
            );
            setFlashMessage('Plano atualizado com sucesso!', 'success');
            return response.data;
        } catch (error) {
            const msg = error.response?.data?.message || 'Erro ao atualizar plano.';
            setFlashMessage(msg, 'error');
            return { error: true };
        }
    }

    /* Assinaturas do usuário */
    async function getMySubscriptions(token) {
        try {
            const response = await api.get('/subscriptions/my', {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data.subscriptions || [];
        } catch (error) {
            return [];
        }
    }

    /* Planos disponíveis */
    async function getPlans(token) {
        try {
            const response = await api.get('/subscriptions/preapproval-plan', {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data.plans || [];
        } catch (error) {
            return [];
        }
    }

    return { subscribe, cancelSubscription, updateSubscription, getMySubscriptions, getPlans };
}